export enum StripePaymentMethod {
  Card = 'card',
  Paypal = 'paypal',
  GooglePay = 'google_pay',
  ApplePay = 'apple_pay',
}
